<template>
	<div id="app">
		<router-view v-wechat-title="$route.meta.title"></router-view>
	</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				text: ''
			};
		}
	};
</script>

<style lang="less" scoped>
	#app {
		min-height: 100%;
		height: 100%;
	}
	#frameWork{
		height:100%;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue